import { pdfjs } from 'react-pdf';

export async function buildTextIndex(src) {
  const loadingTask = pdfjs.getDocument(src);
  const pdf = await loadingTask.promise;

  const pageTexts = []; // index 0 => page 1, etc.

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
    const page = await pdf.getPage(pageNum);
    const content = await page.getTextContent();
    const text = content.items.map((item) => item.str).join(' ');
    pageTexts[pageNum - 1] = text;
  }

  return { pdf, pageTexts }; // you get text for every page
}
export function findPagesWithTerm(pageTexts, term) {
  if (!term) return [];

  const lowerTerm = term.toLowerCase();
  const resultPages = [];

  pageTexts.forEach((text, idx) => {
    if (text.toLowerCase().includes(lowerTerm)) {
      resultPages.push(idx + 1); // page numbers are 1‑based
    }
  });

  return resultPages;
}
export async function shareAnyFile({
  src,
  fileOrBlob,
  fileName,
  mimeType,
  title = 'Share',
  text = '',
}) {
  try {
    let blob;

    if (fileOrBlob instanceof Blob) {
      blob = fileOrBlob;
    } else if (src) {
      const res = await fetch(src, { credentials: 'omit' });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
      blob = await res.blob();
    } else {
      throw new Error('Provide either src or fileOrBlob');
    }

    const finalName = fileName || deriveNameFromSrc(src) || 'file';
    const finalType = mimeType || blob.type || 'application/octet-stream';
    const file = new File([blob], finalName, { type: finalType });

    if (
      navigator.canShare &&
      navigator.canShare({ files: [file] }) &&
      navigator.share
    ) {
      await navigator.share({
        files: [file],
        title,
        text: text || finalName,
      });
      return;
    }
    if (navigator.share) {
      await navigator.share({
        title,
        text: text || finalName,
        url: src || window.location.href,
      });
      return;
    }
    window.location.href = `mailto:?subject=${encodeURIComponent(
      title,
    )}&body=${encodeURIComponent(src || window.location.href)}`;
  } catch (err) {
    console.error('Share failed, falling back to download:', err);
    try {
      if (src) {
        const a = document.createElement('a');
        a.href = src;
        a.download = fileName || deriveNameFromSrc(src) || 'file';
        a.rel = 'noopener';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch {}
  }
}

function deriveNameFromSrc(src) {
  if (!src) return null;
  try {
    const u = new URL(src, window.location.href);
    const last = u.pathname.split('/').pop() || '';
    return decodeURIComponent(last) || null;
  } catch {
    const m = src.split('?')[0].split('#')[0].split('/').pop();
    return m || null;
  }
}
//shares url
export const handleShare = async (file) => {
  const shareData = {
    title: file?.name || 'Document',
    text: 'Check out this document',
    url: window.location.href,
  };
  try {
    if (navigator.share) {
      await navigator.share(shareData);
    } else {
      window.location.href = `mailto:?subject=${encodeURIComponent(
        shareData.title,
      )}&body=${encodeURIComponent(shareData.url)}`;
    }
  } catch (err) {
    if (err?.name !== 'AbortError') console.error(err);
  }
};
//shares pdf as attachment
export const handleSharePdf = async (url, file) => {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const pdfFile = new File([blob], file?.name || 'document.pdf', {
      type: 'application/pdf',
    });

    if (navigator.canShare && navigator.canShare({ files: [pdfFile] })) {
      await navigator.share({
        files: [pdfFile],
        title: file?.name || 'Document',
        text: 'Sharing the PDF',
      });
    } else {
      window.location.href = `mailto:?subject=${encodeURIComponent(
        file?.name || 'Document',
      )}&body=${encodeURIComponent(url)}`;
    }
  } catch (err) {
    if (err?.name !== 'AbortError') console.error(err);
  }
};
